import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "filters-bar" }
const _hoisted_2 = { class: "filter-item" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "search-group" }
const _hoisted_5 = { class: "search-container" }

import { ref, watch, onMounted, computed } from "vue";
import { useUtilitiesStore } from "@/stores/utilities";


const __default__ = {
  name: "LotteryFilters",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["search", "filterCountry"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const search = ref("");
const country = ref("");

const utilitiesStore = useUtilitiesStore();

onMounted(() => {
  // fetchCountries now has caching, safe to call multiple times
  utilitiesStore.fetchCountries();
});

const countryOptions = computed(() => utilitiesStore.countries);

const onSearch = () => emit("search", search.value);
const onCountryFilter = () => emit("filterCountry", country.value);

watch([search, country], () => {
  emit("search", search.value);
  emit("filterCountry", country.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        class: "filter-select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((country).value = $event)),
        onChange: onCountryFilter
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("option", { value: "" }, "All Countries", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryOptions.value, (c) => {
          return (_openBlock(), _createElementBlock("option", {
            key: c.slug,
            value: c.slug
          }, _toDisplayString(c.name), 9, _hoisted_3))
        }), 128))
      ], 544), [
        [_vModelSelect, country.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search-input",
          placeholder: "Search Games...",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
          onInput: onSearch
        }, null, 544), [
          [_vModelText, search.value]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("button", {
          class: "search-button",
          type: "button"
        }, [
          _createElementVNode("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            _createElementVNode("path", {
              d: "M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
              fill: "currentColor"
            })
          ])
        ], -1))
      ])
    ])
  ]))
}
}

})